export default (operationDefinition) => ({
    name: "operation",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'operation %1',
                "args0": [
                    {
                        "type": "field_dropdown",
                        "name": "FIELD",
                        "options": [
                            ["ID", "id"],
                            ["Source", "source"],
                            ...Object.keys(operationDefinition.model.dynaProperties)
                                .map(key => operationDefinition.model.dynaProperties[key])
                                .map(param => {

                                    if (param.details.type === 'DECIMAL') {
                                        return [param.name, "content.getValues().get('" + param.name + "') / " + Math.pow(10, param.details.precision)]
                                    } else {
                                        return [param.name, "content.getValues().get('" + param.name + "')"]
                                    }

                                })
                        ]
                    }
                ],
                "output": null,
                "colour": 4.5,
                "tooltip": "Creates cash event with specified parameters",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {
        let param = block.getFieldValue("FIELD");

        return [`operation.${param}`, blocklyInstance.JavaScript.ORDER_NONE];
        ;
    }
})